<template>
  <div class="articles">
    <ith-top-bar />

    <ith-banner :item="banner" />

    <ith-sad-top />

    <div class="button-reviews-articles">
      <div @click="toggleArticlesArea()" :class="{ active: articlesArea }">
        REVIEWS
      </div>
      <div @click="toggleArticlesArea()" :class="{ active: !articlesArea }">
        ARTICLES
      </div>
    </div>

    <ith-grid-articles-full />
    <ith-sad-bottom />

    <ith-footer />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Articles",
  metaInfo: {
    title: "Latest Movie and TV Series News | Reviews - OTT Watchlist",
    meta: [
      {
        name: "description",
        content:
          "Read OTT Watchlist news and reviews. Learn about IMDB recommended movies and tv show recommendations including deep analysis, reviews, news, and much more.",
      },
      {
        name: "keywords",
        content:
          "Movie news, IMDB recommended movies, tv show recommendations, web series news, movie reviews",
      },
    ],
  },
  mounted() {
    this.$store.commit("DISABLED_MENU");
    this.$store.commit("EDIT_CRITERIA", "");
  },
  computed: mapState(["articlesArea", "banners"]),

  data: () => ({
    banner: {
      title: "",
      text: "",
      image: "./img/banners/REVIEWS_NEWS_IMAGE.png",
    },
  }),
  methods: {
    toggleArticlesArea() {
      this.$store.commit("TOGGLE_ARTICLESAREA");
      this.$store.commit("TOGGLE_TYPEARTICLES");
    },
  },
};
</script>

<style scoped>
.articles {
  background-color: #284367;
}
.button-reviews-articles {
  display: grid;
  grid-template-columns: 200px 200px;
  margin-top: 2%;
  justify-content: center;
}

.button-reviews-articles > div {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 15px 10px;
  cursor: pointer;
  text-align: center;
}
.button-reviews-articles > div.active {
  border-bottom: 3px solid #94c659;
  font-weight: bolder;
}

@media (min-width: 1200px) and (max-width: 1400px) {
  .button-reviews-articles {
    margin-top: 3%;
  }
}

@media (max-width: 1200px) {
  .button-reviews-articles {
    grid-template-columns: 170px 170px;
    font-size: 0.9rem;
    margin-top: 1%;
  }
}
</style>
